export const gitCommit = '07713430'
